import React, { useState, useMemo, memo } from 'react';
import style from './index.module.scss';
import cn from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Loader from '@components/common/Loader/newLoaderModal';
import { ERROR_MESSAGE } from '@constants';
import { CUSTOM_MESSAGES, LABEL } from '@veriables';
import FullWithModal from '@components/common/Modal/FullWidthModal';
import { TouchableButton, TouchableDiv } from '@components/common/Touchable';
import ModalHeader from '../../../../../components/common/ModalHeader/index';
import { setErrorPopUp } from '@reducers/notification';
import {
  setPosition,
  updateSeatInfo,
  setSeat,
  seatClear,
} from '@reducers/orders';

const DeleteSeatModal = ({
  isDeleteSeatModalOpen,
  handleCloseModal,
  ...props
}) => {
  const {
    serverAppTheme,
    deviceInfo,
    check,
    cart,
    userInfo,
    seatClear,

    updateSeatInfo,
    setSeat,
    setPosition,
    setErrorPopUp,
    loading
  } = props; // Redux state imports

  const [selectedSeat, setSelectedSeat] = useState();
  const isLandScape = !!deviceInfo?.deviceGroup?.serverAppSettings
    ?.landscapePaymentMode;

  const popUpModal = useMemo(() => {
    const modal = {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      pointerEvents: 'auto',
      backgroundColor: serverAppTheme?.popUp_bg,
      backgroundClip: 'padding-box',
      height: '100%',
      border: serverAppTheme?.popupBorder,
      boxShadow: serverAppTheme?.popUp_box_shadow,
    };
    const closeIcon = {
      color: serverAppTheme?.iconcolor,
    };
    const primaryTextColor = { color: serverAppTheme?.primary_text };
    const deleteSeat = {
      height: '44px',
      backgroundColor: serverAppTheme?.secondaryBtn,
      color: '#ffff',
      border: 'none',
      borderRadius: '8px',
    };
    const deleteSeatDisabled = {
      height: '44px',
      backgroundColor: serverAppTheme?.secondaryBtnDisabled,
      color: serverAppTheme?.secondary_btn_disable_text,
      border: 'none',
      borderRadius: '8px',
    };
    return {
      modal,
      closeIcon,
      primaryTextColor,
      deleteSeat,
      deleteSeatDisabled,
    };
  }, [serverAppTheme, isLandScape]);

  const handleClear = data => {
    if (cart.some(e => e.seatIds.includes(data.id) && e.pending)) {
      setErrorPopUp({
        res: ERROR_MESSAGE.SEND_PENDING_ITEMS,
      });
    } else {
      const dataToSend = {
        storeId: deviceInfo.storeId,
        employeeId: Number(userInfo.id),
        employeeCard: userInfo.employeeCard,
        deviceId: deviceInfo.deviceId,
        checkHeaderId: check.id,
        stationId: check.stationId || null,
        seats: [
          {
            seatId: data.id,
          },
        ],
      };
      seatClear(dataToSend)
        .then(res => {
          updateSeatInfo(res);
          setSeat(res);
          setPosition({ number: -1, position: -1 });
          handleCloseModal();
        })
        .catch(err => {
          setErrorPopUp({
            res: err.message,
          });
        });
    }
  };

  const handleSeatClick = () => {
    if (!selectedSeat) {
      setErrorPopUp({
        res: CUSTOM_MESSAGES().DELETE_SEAT_ERROR,
        noErrorTxt: true,
        onClickChange: () => {},
      });
    } else {
      setSelectedSeat();
      handleClear(selectedSeat);
    }
  };

  return (
    <FullWithModal
      isModalCenter
      isOpen={isDeleteSeatModalOpen}
      customClass2={cn('w-100 h-100')}
      style={popUpModal.modal}
      noBackground
    >
      <>{loading && <Loader />}</>
      <div
        className="col-12 px-0 justify-content-center align-items-center position-relative text-center h-100"
        style={popUpModal.primaryTextColor}
      >
        <div
          className={cn(
            'col-12 px-0 fs_18 d-flex align-items-center justify-content-center fw-600'
          )}
        >
          <ModalHeader
            isTab={check?.tab}
            stationName={check?.stationName}
            tileHeader={LABEL().DELETE_SEAT_TITLE}
            seatNumber={check?.number}
          />
        </div>
        <div className="fs_18 fw-600 text-center py-3">
          {LABEL().SELECT_A_SEAT_TO_DELETE}
        </div>
        <div
          className={cn(
            'col-12 px-0 large-input m-auto justify-content-center  position-relative h-90'
          )}
        >
          <TouchableDiv className={cn('col-12 px-3 w-100 overflowY h-76')}>
            <div
              className={cn(
                'col-12 row p-0 mx-0 flex-wrap overflowY w-100',
                style.wrapperDeleteSeat
              )}
            >
              {check?.seats.map((el, index) => (
                <>
                  {el.open && (
                    <div
                      className={cn(
                        style.btnBorderWhite,
                        selectedSeat && selectedSeat.id === el.id
                          ? `${style.selectedSeats} `
                          : `${style.unSelectedSeats} `,
                        'd-flex justify-content-center align-items-center border rounded  fs_32'
                      )}
                      role="button"
                      tabIndex="0"
                      onClick={() => setSelectedSeat(el)}
                      style={{
                        color:
                          selectedSeat?.id === el.id
                            ? '#000'
                            : serverAppTheme?.primary_text,
                        border:
                          selectedSeat?.id === el.id
                            ? 'none'
                            : serverAppTheme?.popupBorder,
                        background:
                          selectedSeat?.id === el.id
                            ? serverAppTheme?.selected
                            : serverAppTheme?.unselected,
                        height: '85px',
                        outline: 'none',
                      }}
                    >
                      {el.number}
                      <br />
                      <span className={style.tableName}>{el.name}</span>
                    </div>
                  )}
                </>
              ))}
            </div>
          </TouchableDiv>
          <div className="d-flex col-12 justify-content-center">
            <div className="col-5 pr-1">
              <TouchableButton
                type="button"
                className={cn(
                  'px-0 mb-2 pl-2 mt-2 rounded btn-ripple fs_24 fw-600 w-100 btn44'
                )}
                onClick={e => {
                  e.preventDefault();
                  handleCloseModal();
                  setSelectedSeat();
                }}
                style={{
                  backgroundColor: serverAppTheme?.OFF_Premise_Btn,
                  border: serverAppTheme?.cancleBtn_Border,
                  color: serverAppTheme?.cancleBtn_font,
                }}
                rippleEffect={true}
              >
                {LABEL().CANCEL}
              </TouchableButton>
            </div>
            <div className={cn('col-5 pl-1')}>
              <TouchableButton
                className={cn('w-100 mt-2 btn-ripple')}
                type="button"
                onClick={handleSeatClick}
                style={popUpModal.deleteSeat}
                rippleEffect={true}
              >
                <div className="fs_24  fw-600">{LABEL().DELETE_SEAT}</div>
              </TouchableButton>
            </div>
          </div>
        </div>
      </div>
    </FullWithModal>
  );
};

const mapStateToProps = ({ theme, oauth, orders }) => ({
  serverAppTheme: theme.serverAppTheme,

  deviceInfo: oauth.deviceInformation,
  userInfo: oauth.loggedInUserData,

  check: orders.seats,
  cart: orders.cart,
  loading: orders.loading,
});

const mapDispatchToProps = dipatch =>
  bindActionCreators(
    {
      setErrorPopUp,
      seatClear,
      updateSeatInfo,
      setPosition,
      seatClear,
      setSeat,
    },
    dipatch
  );

const MemoizedDeleteModal = memo(DeleteSeatModal);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MemoizedDeleteModal);
